import { useNavigate, useParams } from 'react-router-dom';
import { backArrow } from '../../../../assets/svg';
import { CashbackTransaction } from '../../../../types';
import { useAppDispatch } from '../../../../hooks';
import React from 'react';
import { PrimaryButton, Table } from '../../../components';
import { cashbackColumns } from '../../../../constants';
import { getCashbackTransactionById } from '../../../../store/slices';

const Cashback = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { cashbackId } = useParams();
  const [cashbackTransactions, setCashbackTransactions] = React.useState<
    CashbackTransaction[]
  >([]);
  //const { cashbacks, loading } = useAppSelector(cashbackSelector);

  const goBack = () => {
    navigate(-1);
  };

  // const resetFilters = () => {
  //   setShowFilters(false);
  //   navigate(`/dashboard/coupon/cashback`);
  // };

  React.useEffect(() => {
    const getAllCashbacks = async () => {
      try {
        const result = await dispatch(
          getCashbackTransactionById({ id: parseInt(cashbackId!) })
        );
        if (result.type.endsWith('/fulfilled')) {
          setCashbackTransactions(result.payload as CashbackTransaction[]);
        } else {
          throw new Error('Failed to fetch cashbacks');
        }
      } catch (error) {
        console.error(error);
      }
    };
    getAllCashbacks();
  }, [dispatch, cashbackId]);

  return (
    <div className="body1">
      <button
        className="flex items-center space-x-2 text-sm mb-2"
        onClick={goBack}
      >
        <img src={backArrow} alt="back" />
        <span className="semibold">Back</span>
      </button>
      <div>
        <div className="flex justify-between items-center">
          <h1 className="semibold text-xl">Cashback Transactions</h1>
          <PrimaryButton
            text="See all cashback"
            onClick={() => navigate('/dashboard/coupons/cashback-config')}
          />
        </div>

        <div>
          <Table
            columns={cashbackColumns}
            data={cashbackTransactions ?? []}
            tableFor={'transactions'}
          />
        </div>
      </div>
    </div>
  );
};

export default Cashback;
